import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export const useGetKeyInvestigation = (keyId: string | undefined): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.GET_KEY_INVESTIGATION, { keyId }],
    {
      enabled: !!keyId,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    }
  );
};
